/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClockTimestamp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 3a8 8 0 1 0 0 16v2C5.477 21 1 16.523 1 11S5.477 1 11 1a10 10 0 0 1 8.96 5.555l-1.791.89A8 8 0 0 0 11 3zm-1 7V5h2v7H7v-2zm8 1a2 2 0 0 1 2 2c0 .27-.125.83-.615 1.211l-.385.3V17h-2v-2.489l-.386-.3A1.62 1.62 0 0 1 16 13a2 2 0 0 1 2-2zm3 8v2h-6v-2zm-6-2h-2v6h10v-6h-2v-1.558c.791-.824 1-1.838 1-2.442a4 4 0 0 0-8 0c0 .604.209 1.618 1 2.442z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgClockTimestamp as ClockTimestamp };
